<script>
export default {
    name: "StockJournalApproval",

    data () {

        return {

            journals: [],
            description: "",
            journalDetails: {
                inventoryJournals: [],
                date: window.moment().format('YYYY-MM-DD'),
                userName: this.$root.username,
            },
            checked: false,
            confirmApproval: false,
            confirmDecline: false
        };
    },

    watch: {

        "journalDetails.date" () {

            if (!this.journalDetails.date) return;

            this.fetchJournals();
        }
    },

    components: {

        "confirm-decline": () => import('./modals/DeclineJournalApproval.vue'),
        "confirm-approval": () => import('./modals/ConfirmJournalApproval.vue'),
    },

    mounted () {

        this.fetchJournals();
    },

    methods: {

        fetchJournals() {

            this.$root.loading = true;
            this.$accountsHttp.get(`InventoryJournal/GetInventoryJournals?UserName=${this.journalDetails.userName}&Date=${this.journalDetails.date}`)
                .then(response => {
                    this.journals = response.data;
                    this.$root.loading = false;
                }).catch(() => this.$root.loading = false);
        },
    }
}
</script>
<template>
<div class="flex flex-wrap w-full mt-px">
    <div class="md:w-1/12 sm:w-1/2 p-tiny">
        <label for="checked"><input type="checkbox" v-model="checked" :value="true" id="checked">All</label>
    </div>
    <div class="md:w-1/4 sm:w-1/2 p-tiny">
        <input class="input-control input-sm text-xs" v-model.trim="journalDetails.date" type="date" id="date">
    </div>
    <div class="w-full overflow-auto">
        <table class="table table-hover">
            <thead class="bg-blue-500 text-xs text-white">
                <tr class="flex w-full">
                    <th class="p-tiny w-1/12">Code</th>
                    <th class="p-tiny w-1/6">Type</th>
                    <th class="p-tiny w-1/6">Store</th>
                    <th class="p-tiny w-1/6">Item</th>
                    <th class="p-tiny w-1/12">Qty</th>
                    <th class="p-tiny w-1/12">Expiry Date</th>
                    <th class="p-tiny w-1/12">Description</th>
                    <th class="p-tiny w-1/12">Unit Cost</th>
                    <th class="p-tiny w-1/12">Username</th>
                    <th class="p-tiny w-1/12">Action</th>
                </tr>
            </thead>
            <tbody class="flex flex-col items-center text-xs overflow-auto bg-gray-100" style="height:55vh;">
                <tr class="w-full flex" v-for="(journal, idx) in journals" :key="idx">
                    <td class="p-tiny w-1/12">{{ journal.deductionID }}</td>
                    <td class="p-tiny w-1/6">{{ journal.deductionType }}</td>
                    <td class="p-tiny w-1/6">{{ journal.store }}</td>
                    <td class="p-tiny w-1/6">{{ journal.item }}</td>
                    <td class="p-tiny w-1/12">{{ journal.qty }}</td>
                    <td class="p-tiny w-1/12">{{ journal.expiryDate | dateFormat }}</td>
                    <td class="p-tiny w-1/12">{{ journal.description || `-` }}</td>
                    <td class="p-tiny w-1/12">{{ journal.price }}</td>
                    <td class="p-tiny w-1/12">{{ journal.userName }}</td>
                    <td class="p-tiny w-1/12">
                        <input type="checkbox" :checked="checked" v-model="journalDetails.inventoryJournals" :value="journal">
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="flex mt-2 w-full">
        <div class="flex-1">
            <label for="description">Description</label>
            <textarea id="description" v-model="journalDetails.description"  cols="30" rows="1" class="input-control text-xs"></textarea>
        </div>
        <div class="flex-1 mt-3">
            <div class="flex justify-end">
                <button class="btn-danger btn-sm text-xs rounded mr-4" 
                    @click.prevent="() => { if(!journalDetails.inventoryJournals.length) return; confirmDecline = true; }">
                    <i class="fa fa-times"></i> Decline</button>
                <button class="btn-primary btn-sm text-xs rounded" 
                    @click.prevent="() => { if(!journalDetails.inventoryJournals.length) return; confirmApproval = true; }">
                    <i class="fa fa-check"></i> Approve</button>
            </div>
            <confirm-approval 
                :showModal="confirmApproval" 
                :journalDetails="journalDetails" 
                @closeModal="() => { fetchJournals(); confirmApproval=false; }"/>
            <confirm-decline 
                :showModal="confirmDecline" 
                :journalDetails="journalDetails" 
                @closeModal="() => { fetchJournals(); confirmDecline=false; }"/>
        </div>
    </div>
</div>
    
</template>
